
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"21","height":"22","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"var(--brand-primary)","stroke":"var(--brand-primary)","stroke-width":".4","d":"M7.313 21.7h10.5a2.39 2.39 0 002.387-2.387V6.188A2.39 2.39 0 0017.813 3.8h-10.5a2.39 2.39 0 00-2.388 2.388v13.125A2.39 2.39 0 007.313 21.7zM6.2 6.188c0-.614.5-1.113 1.112-1.113h10.5c.614 0 1.113.5 1.113 1.112v13.125c0 .614-.5 1.113-1.113 1.113h-10.5c-.613 0-1.112-.5-1.112-1.113V6.188z"}}),_c('path',{attrs:{"fill":"var(--brand-primary)","d":"M14.428 14.875H9.202c-.18 0-.327-.196-.327-.438 0-.241.146-.437.327-.437h5.226c.18 0 .327.196.327.438 0 .241-.146.437-.327.437zm-3.778 3.5H8.98c-.058 0-.105-.196-.105-.438 0-.241.047-.437.104-.437h1.672c.057 0 .104.196.104.438 0 .241-.047.437-.104.437zm5.663-7h-7a.438.438 0 110-.875h7a.438.438 0 01-.001.875zm0-3.5h-7a.438.438 0 110-.875h7a.438.438 0 01-.001.875z"}}),_c('path',{attrs:{"fill":"var(--brand-primary)","stroke":"var(--brand-primary)","stroke-width":".4","d":"M3.188 19.575h.874a.638.638 0 100-1.275h-.875c-.613 0-1.112-.5-1.112-1.113v-14c0-.613.5-1.112 1.112-1.112h10.5c.614 0 1.113.5 1.113 1.112a.638.638 0 101.275 0A2.39 2.39 0 0013.688.8h-10.5A2.39 2.39 0 00.8 3.188v14a2.39 2.39 0 002.388 2.387z"}})])
          )
        }
      }
    